import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersAthletesRoutingModule } from './members-athletes-routing.module';
import { BootstrapMembersAthletesComponent } from './bootstrap-members-athletes/bootstrap-members-athletes.component';
import { MembersAthletesTableComponent } from './bootstrap-members-athletes-table/bootstrap-members-athletes-table.component';
import { MembersAthletesFiltersComponent } from './bootstrap-members-athletes-filters/bootstrap-members-athletes-filters.component';
import { CommonPageComponentsModule } from '../../../common-page-components/common-page-components.module';
import { CoreModule } from '../../../library/core.module';
import { MembersAthletesFiltersServiceService } from './services/members-athletes-filters-service.service';
import { ServicesModule } from 'world-archery-lib';

@NgModule({
  declarations: [BootstrapMembersAthletesComponent, MembersAthletesTableComponent, MembersAthletesFiltersComponent],
  imports: [
    CommonModule,
    CoreModule,
    MembersAthletesRoutingModule,
    CommonPageComponentsModule,
    ServicesModule
  ],
  providers: [
    MembersAthletesFiltersServiceService
  ],
  exports:[
    CoreModule,
    ServicesModule,
    BootstrapMembersAthletesComponent,
    MembersAthletesTableComponent,
    MembersAthletesFiltersComponent
  ]
})
export class MembersAthletesModule { }
